export enum AddAndReduceStatusEnum {
  GENERAL = 'GENERAL',
  ORDER_CREATION = 'ORDER_CREATION',
  SINGLE_PAGE = 'SINGLE_PAGE',
  BASKET = 'BASKET',

}
